'use client'

import { BreadcrumbCustom } from '@/components/atoms/breadcrumb'
import { ArticleRecommendationCarousel } from '@/components/molecules/carousel/article-recommendation-carousel'
import Container from '@/components/templates/container/container'

interface ArticleRecommendationProps {
  data: Article
}

export const ArticleRecommendation = ({ data }: ArticleRecommendationProps) => {
  const items = [
    {
      label: 'Beranda',
      url: '/'
    },
    {
      label: 'Artikel'
    }
  ]

  if (!data.items.length) {
    return null
  }

  return (
    <section>
      <h1 className="sr-only">Halaman Artikel</h1>
      <Container>
        <BreadcrumbCustom items={items} className="py-5 text-sm lg:text-base lg:py-9" />

        <article className="pb-5 space-y-6 lg:pb-16 lg:space-y-9">
          <h2 className="text-2xl font-extrabold lg:text-4xl text-secondary-blue">Artikel Rekomendasi</h2>
          <ArticleRecommendationCarousel data={data} />
        </article>
      </Container>
    </section>
  )
}
